import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  subtext?: string;
  className?: string;
}
export function CTAButton({
  text = '🌿 QUIERO MI GUÍA COMPLETA AHORA',
  subtext,
  className = ''
}: CTAButtonProps) {
  return <a href="https://impulsodigital.vip/cart/44742359646294:1" className={`block w-full max-w-xl mx-auto group ${className}`} data-id="element-33">
      <div className="relative" data-id="element-34">
        <div className="absolute -inset-1 bg-brand-green rounded-xl blur opacity-30 group-hover:opacity-50 transition duration-200" data-id="element-35"></div>
        <button className="relative w-full bg-brand-green hover:bg-green-700 text-white font-heading font-bold text-xl md:text-2xl py-5 px-6 rounded-xl shadow-[0_8px_0_rgb(21,128,61)] hover:shadow-[0_4px_0_rgb(21,128,61)] hover:translate-y-1 transition-all duration-200 flex flex-col items-center justify-center gap-2 animate-pulse-fast" data-id="element-36">
          <span className="flex items-center gap-2 text-center" data-id="element-37">
            {text}
            <ArrowRight className="w-6 h-6 hidden md:block" data-id="element-38" />
          </span>
          {subtext && <span className="text-sm md:text-base font-sans font-normal opacity-90 text-center" data-id="element-39">
              {subtext}
            </span>}
        </button>
      </div>
    </a>;
}